<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-4': mobile,
          'pt-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">Create Announcement</p>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="12">
            <v-text-field
              v-model="subject"
              label="Subject"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="12">
            <v-textarea
              v-model="message"
              label="Message"
              required
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  v-bind="attrs"
                  readonly
                  outlined
                  dense
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                scrollable
                @change="updateStartDate"
                @input="startDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  v-bind="attrs"
                  readonly
                  outlined
                  dense
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :allowed-dates="allowedEndDate"
                no-title
                scrollable
                @input="endDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="12">
            <v-file-input
              v-model="attachments"
              accept="image/*"
              label="Upload Attachments"
              prepend-icon=""
              chips
              small-chips
              multiple
              outlined
              dense
            >
              <template v-slot:prepend-inner>
                <v-icon small class="mt-1">mdi-paperclip</v-icon>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="finish">Finish</v-btn>
          <v-btn color="grey darken-1" text @click="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      subject: '',
      message: '',
      attachments: null,
      startDate: dayjs().startOf('day').format('YYYY-MM-DD'),
      endDate: dayjs().startOf('day').format('YYYY-MM-DD'),
      startDateMenu: false,
      endDateMenu: false,
      loading: false
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open() {
      this.dialog = true
      this.attachments = []
      //this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      try {
        this.loading = true
        await this.$store.dispatch('announcements/newAnnouncementAction', {
          subject: this.subject,
          message: this.message,
          startDate: dayjs(this.startDate).format(),
          endDate: dayjs(this.endDate).format(),
          attachments: this.attachments
        })
        this.loading = false
        this.dialog = false
        this.$root
          .$confirm({
            title: 'Create Announcement',
            message: `Announcement has been created.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'primary'
            }
          })
          .then(async () => {
            this.resolve(true)
          })
      } catch (err) {
        this.loading = false
        this.$root.$confirm({
          title: 'Create Announcement',
          message: err,
          options: {
            color: 'error'
          },
          reconfirmOnly: true,
          confirmText: 'OK'
        })
      }
    },
    cancel() {
      this.dialog = false
      this.loading = false
      this.resolve(false)
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    updateStartDate(val) {
      if (dayjs(val) > dayjs(this.endDate)) {
        this.endDatePicker = val
        this.endDate = val
      }
    },
    allowedEndDate(val) {
      return dayjs(val).isAfter(dayjs(this.startDate).subtract(1, 'day'), 'day')
    }
  }
}
</script>
